angular.module 'zc.core', [
  'ui.router'
  'pascalprecht.translate'
  'LocalStorageModule'
]




// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/index.js.coffee